export const WCP_EMAIL_STYLES = `
.wcp-body { margin: 0; padding: 0; background-color: #f4f6fc; font-family: Arial, Helvetica, sans-serif; }
.wcp-container { max-width: 640px; margin: 0 auto; background-color: #ffffff; }
.wcp-grid { border-collapse: collapse; table-layout: fixed; max-width: 100%; }
.wcp-row { width: 100%; }
.wcp-col { vertical-align: top; box-sizing: border-box; padding: 0; }
.wcp-cell-inner { box-sizing: border-box; width: 100%; background-clip: padding-box; }
.wcp-layout-inner { box-sizing: border-box; background-clip: padding-box; }
.wcp-h1, .wcp-h2, .wcp-h3, .wcp-p { margin: 0; line-height: 1.5; }
.wcp-btn { display: inline-block; text-decoration: none; font-weight: 600; font-size: 14px; line-height: 1.5; }
.wcp-img { display: block; max-width: 100%; height: auto; border: 0; }
.wcp-img-placeholder { color: #999999; text-align: center; padding: 16px; }
.wcp-html { line-height: 1.5; }
`.trim();

/** Editor preview-only overrides: fluid width, no horizontal scroll inside iframe. */
export const WCP_PREVIEW_STYLES = `
html, body { overflow-x: hidden !important; }
.wcp-container { max-width: 100% !important; width: 100% !important; margin: 0 !important; }
.wcp-grid { width: 100% !important; max-width: 100% !important; table-layout: fixed !important; }
.wcp-img { max-width: 100% !important; height: auto !important; }
.wcp-html, .wcp-html * { max-width: 100%; box-sizing: border-box; }
table { max-width: 100% !important; }
`.trim();

export const WCP_CLASS = {
  body: "wcp-body",
  container: "wcp-container",
  grid: "wcp-grid",
  row: "wcp-row",
  col: "wcp-col",
  cellInner: "wcp-cell-inner",
  layoutInner: "wcp-layout-inner",
  h1: "wcp-h1",
  h2: "wcp-h2",
  h3: "wcp-h3",
  p: "wcp-p",
  btn: "wcp-btn",
  img: "wcp-img",
  imgPlaceholder: "wcp-img-placeholder",
  html: "wcp-html",
};
 